/* eslint-disable */
export default {
    sidebar_my_assessments: "Invitations",
    sidebar_welcome: "Bienvenue",
    sidebar_logout_could_not_logout: "Impossible de se déconnecter",
    sidebar_logout_logout_text: "Se déconnecter",
    sidebar_update_personal_details: "Profil personnel",
    sidebar_feature_toggles_menu_item: "Feature toggles",
    sidebar_reports_menu_item: "Rapports"
};
